import { useIcon } from '../icon/useIcon'
import { Toast, ToastPosition, ToastType } from '../toast/Toast'
import { createEffect, createSignal, on, onCleanup, Show } from 'solid-js'
import './logintvform.css'
import {useConfig} from '../config/useConfig'
import {FocusGroupProvider, FocusableProvider} from '../focus/index'
import {useSpatialNavigation} from '../../spatialNavigation'
import {onMount} from 'solid-js'
import {isPlatform} from '../../utils'
import {useI18n} from '../../i18n'
import {useSelector, useDispatch} from '../../store'
import {isConnectedInOperatorNetwork} from '@te_react/volt-store/lib/actions'
import { useToast } from '../toast/useToast'

interface LoginTVFormProps {
    onLoginTVForm: (username: string, password: string) => void
    username: string
    password: string
    failed: boolean
    statusCode:string
    OAuthStatus:string
    onLoginTVForgetForm?: () => void;
    onLoginTVComplete?: () => void;
}

export const LoginTVForm = (props: LoginTVFormProps) => {
    const {getI18n} = useI18n()
    const {getConfig} = useConfig()

    const icons = useIcon()
    const {setFocus} = useSpatialNavigation()
    const { show } = useToast()

    const [usernameOrEmail, setUsernameOrEmail] = createSignal(props.username);
    const [formPassword, setFormPassword] = createSignal(props.password);
    const [error, setError] = createSignal('');
    const [isToast, setisToast] = createSignal(false)
    const [usernameRef, setUsernameRef] = createSignal<any>(null)
    const locale = useSelector((state: any) => state?.language?.locale)
    const dispatch = useDispatch()
    const [showNoInternetToast, setShowNoInternetToast] = createSignal(false)
    const [isLoading, setIsLoading] = createSignal(false)

    const handleUsernameOrEmailChange = (e: {target: {value: any}}) => {
        setUsernameOrEmail(e.target.value)
    }

    const handlePasswordChange = (e: {target: {value: any}}) => {
        setFormPassword(e.target.value)
    }

    createEffect(
        on(
            () => usernameRef(),
            () => {
                if (usernameRef() && !usernameOrEmail()) {
                    document.getElementById("usernameOrEmail")?.focus()
                }
            })
    )

    createEffect(() => {
        if (showNoInternetToast()) {
            setTimeout(() => {
                setShowNoInternetToast(false)
            }, 3000)
        }
    })


    const handleRemoteControlInput = (event:any) => {
        if(event?.keyCode === 37){
          event.preventDefault();
          moveCursorLeft(event?.target)
        }
        else if(event.keyCode === 39){
            moveCursorRight(event?.target)
        }
        else if(event.key === "Enter"){
            event?.target?.blur();
        }
      };

    onMount(() => {
        // Add an event listener for keydown events
        window.addEventListener('keydown', handleRemoteControlInput);
        if (!isPlatform('laptop')) {
            if (document.getElementById("usernameOrEmail") && !usernameOrEmail()) {
                setFocus(`usernameOrEmail`)
                document.getElementById('usernameOrEmail')?.focus()
            }else if(props?.failed){
                setFocus('loginformbutton')
            }else
            {
                setFocus('loginformbutton')
            }
        }
    })

    // Cleanup to remove the event listener when the component is unmounted
    onCleanup(() => {
        window.removeEventListener('keydown', handleRemoteControlInput);
        setUsernameOrEmail('')
        setFormPassword('')
    });

    /*
  Move cursor left by click on left arrow from virtual keyboard
  */
  const moveCursorLeft = (inputElement:any) => {
    const currentPosition = inputElement?.selectionStart;
    if (currentPosition > 0) {
      inputElement?.setSelectionRange(currentPosition - 1, currentPosition - 1);
    }
  }

  /*
  Move cursor right by click on right arrow from virtual keyboard
  */
  const moveCursorRight = (inputElement:any) => {
      const currentPosition = inputElement?.selectionStart;
      const textLength = inputElement?.value?.length;
      if (currentPosition < textLength) {
        inputElement?.setSelectionRange(currentPosition + 1, currentPosition + 1);
      }
    }


    createEffect(() => {
        if (isToast()) {
            const timeoutId = setTimeout(() => {
                setisToast(false)
                // added bellow code to check login functionality is completed
                props?.onLoginTVComplete && props?.onLoginTVComplete()
            }, 3000)

            // Cleanup function to clear timeout
            return () => clearTimeout(timeoutId)
        }
    })

    const handleForgetPasswordSubmit = () => {
        // Perform login (Here you might make an API call to validate credentials)
        props?.onLoginTVForgetForm && props?.onLoginTVForgetForm()
    }

    createEffect(
        on(
            () => isToast() && props.failed && !error(),
            () => {
                if(isToast() && props.failed && !error() && props.OAuthStatus != 'TIMEOUT_LOGIN_SECONDARY_DEVICE' && props.statusCode !='NAV-010-UFI'){
                    if(!window.navigator.onLine){
                        show({
                            title: 'NO_INTERNET',
                            description: getI18n()?.formatMessage({id: 'NO_INTERNET'}),
                            type: ToastType.ERROR,
                            onClose: () => setisToast(false)
                        })
                    } else {
                        show({
                            title: 'NO_INTERNET',
                            description: getI18n()?.formatMessage({id: 'LOGIN_FAILED_INVALID_CRED'}),
                            type: ToastType.ERROR,
                            onClose: () => setisToast(false)
                        })
                    }
                }
            }
        )
    )

    const handleSubmit = () => {
        // Perform login (Here you might make an API call to validate credentials)
        props?.onLoginTVForm(usernameOrEmail(), formPassword())
        setError('')
    }

    const handleLoginClick = () => {
        setIsLoading(true)
        dispatch(isConnectedInOperatorNetwork({
            "onSuccess": () => {
                setIsLoading(false);
                setShowNoInternetToast(false)
                handleSubmit();
            },
            "onFailed": () => {
                setIsLoading(false);
                setShowNoInternetToast(true)
                return;
            },
            "retries": []
        }))
    }

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key !== 'Enter') return
        handleLoginClick()
    }

    return (
        <FocusGroupProvider id={`logintvform-screen`} focusKey={`logintvform-screen`} onFocus={() => {}}>
            <div
                id={`${isPlatform('laptop') ? 'logintvform-screen' :''}`} 
                class="login-content-tvform-main"
                style={
                    ((getConfig()?.client === 'starhub'))
                      ? {
                          display: isLoading() ? "none" : "flex",
                          'justify-content': 'center',
                          'align-items': 'center',
                          height: '100vh',
                          'background-image': `url(${icons.get('LoginBackdrop')})`,
                          'background-size': 'cover',
                          direction: getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr',
                        }
                      : {}
                  }
            >
                <div class="login-content-tvform">
                    <div class="client_logo_loading_logout_screen"></div>
                    <div>
                        <label class="usernameOrEmail" for="usernameOrEmail">
                            {getI18n()?.formatMessage({id: 'USERNAME_OR_EMAIL'})}
                        </label>
                        <FocusableProvider
                            focusKey={`usernameOrEmail`}
                            onFocus={() => {
                                document.getElementById('usernameOrEmail')?.focus()
                            }}
                            onBlur={() => {
                                document.getElementById('usernameOrEmail')?.blur()
                            }}
                        >
                            {(focused: any) => (
                                <input
                                    ref={(e) => { setUsernameRef(e) }}
                                    type="text"
                                    id="usernameOrEmail"
                                    autocomplete="off"
                                    value={usernameOrEmail()}
                                    onInput={handleUsernameOrEmailChange}
                                    required
                                    class={`login-input ${focused?.() ? 'login-input-focus' : ''}`}
                                    onClick={() => {setFocus('usernameOrEmail')}}
                                    onKeyDown={handleKeyDown}
                                />
                            )}
                        </FocusableProvider>

                        <label class="formPassword" for="formPassword">
                            {getI18n()?.formatMessage({id: 'PASSWORD'})}
                        </label>
                        <FocusableProvider
                            focusKey={`formPassword`}
                            onFocus={() => {
                                document.getElementById('formPassword')?.focus()
                            }}
                            onBlur={() => {
                                document.getElementById('formPassword')?.blur()
                            }}
                            onArrowPress={(direction: any) => {
                                if (direction === 'down') {
                                    setFocus('loginformbutton')
                                }
                            }}
                        >
                            {(focused: any) => (
                                <input
                                    type="password"
                                    id="formPassword"
                                    autocomplete="off"
                                    value={formPassword()}
                                    onInput={handlePasswordChange}
                                    class={`login-input ${focused?.() ? 'login-input-focus' : ''}`}
                                    required
                                    onClick={() => {setFocus('formPassword')}}
                                    onKeyDown={handleKeyDown}
                                />
                            )}
                        </FocusableProvider>
                    </div>

                    <Show when={props.failed && !error()}>{setisToast(true)}</Show>

                    <div id='loginbuttoncomb' class={`${!getConfig()?.forgotPassword ? 'nologinbuttoncomb' : '' }`}>
                        <Show when={getConfig()?.forgotPassword}>
                            <div id={`${isPlatform('laptop') ? 'loginformforgotbutton' :''}`}>   
                            <FocusableProvider
                                id={'loginformforgotbutton'}
                                focusKey={`loginformforgotbutton`}
                                onEnterPress={handleForgetPasswordSubmit()}
                                onFocus={() => {
                                    document.getElementById('loginformforgotbutton')?.focus()
                                }}
                            >
                                {(focused: any) => (
                                    <button
                                        id="loginforgotbutton"
                                        class={`login-content-button-forgot-tv ${focused?.() ? 'login-content-button-tv-forgot-focus' : ''}`}
                                        tabIndex={focused?.() ? 0 : -1}
                                        type="submit"
                                        onClick={()=>{
                                            handleForgetPasswordSubmit()
                                            }
                                        }
                                    >
                                        {getI18n()?.formatMessage({id: 'FORGOT_PASSWORD'})}
                                    </button>
                                )}
                            </FocusableProvider>
                            </div>
                    </Show>
                    <div id={`${isPlatform('laptop') ? 'loginformbutton' :''}`}>            
                    <FocusableProvider
                        id={'loginformbutton'}
                        focusKey={`loginformbutton`}
                        onEnterPress={() => document.getElementById('loginbutton')?.click()}
                        onFocus={() => {
                            document.getElementById('loginformbutton')?.focus()
                        }}
                    >
                        {(focused: any) => (
                            <button
                                id="loginbutton"
                                class={`login-content-button-tv ${focused?.() ? 'login-content-button-tv-focus' : ''}`}
                                tabIndex={focused?.() ? 0 : -1}
                                type="submit"
                                onClick={handleLoginClick}
                            >
                                {getI18n()?.formatMessage({id: 'LOG_IN'})}
                            </button>
                        )}
                    </FocusableProvider>
                    </div>
                    </div>
                </div>
                <Show when={showNoInternetToast()}>
                    <Toast
                        onClose={() => setShowNoInternetToast(false)}
                        title={getI18n()?.formatMessage({id: 'ERROR'})}
                        description={getI18n()?.formatMessage({id: 'NO_INTERNET'})}
                        type={ToastType.ERROR}
                        position={ToastPosition.TOP_CENTER}
                    />
                </Show>
            </div>
        </FocusGroupProvider>
    )
}